import React, { useState, useEffect } from 'react';
import './App.css';
import Loader from './Loader';
import { getLivestreamDetails, getUserProfile } from './service';
import { useLocation, useHistory } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import { generateIV, encrypt } from './zoomEncryption';

declare var ZoomMtg;

// temporary
ZoomMtg.setZoomJSLib('https://source.zoom.us/3.8.10/lib', '/av');

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();
// loads language files, also passes any error messages to the ui
ZoomMtg.i18n.load('en-US');
ZoomMtg.i18n.reload('en-US');

function OldApp() {
    const [userToken, setUserToken] = useState('');
    const [livestreamId, setLivestreamId] = useState('');
    const [zoomCredential, setZoomCredential] = useState({
        userName: '',
        userEmail: '',
        passWord: '',
        meetingNumber: '',
        // apiKey: '',
        sdkKey: '',
        signature: '',
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isRequirementsMet, setIsRequirementsMet] = useState(true);
    const [sdkVersion, setSdkVersion] = useState('3.8.10');
    const location = useLocation();
    const history = useHistory();
    const exitDelay = 3; // in seconds

    useEffect(() => {
        try {
            const { pathname } = location;

            if (!pathname) {
                setIsLoading(false);
            }
            
            const checkSystemRequirements = ZoomMtg.checkSystemRequirements();
            const zoomSDKVersion = ZoomMtg.getWebSDKVersion();
            setSdkVersion(zoomSDKVersion[0] || '3.8.10');

            const credential = String(pathname).substring(1);
            const { token, livestreamId } = JSON.parse(CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(credential, process.env.REACT_APP_DECRYPT_SECRET_KEY)));
            
            if (!token || !livestreamId || !checkSystemRequirements) {
                if (!checkSystemRequirements) setIsRequirementsMet(false);
                throw new Error();
            }
            
            setUserToken(token);
            setLivestreamId(livestreamId);
        } catch (e) {
            console.log("didMount useEffect error", e, e.message);
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        let redirectTimeout = null;

        if (!isLoading) {
            redirectTimeout = setTimeout(() => {
                history.push('/ended');
            }, exitDelay * 1000);
        }

        return () => {
            if (redirectTimeout) clearTimeout(redirectTimeout);
        }
    }, [isLoading, setIsLoading]);

    useEffect(() => {
        if (userToken && livestreamId) getDatas();
    }, [userToken, livestreamId]);

    useEffect(() => {
        if (!zoomCredential.signature) return;

        startMeeting();
    }, [zoomCredential.signature]);

    async function getDatas() {
        try {
            const [userProfile, livestream] = await Promise.all([getUserProfile(userToken), getLivestreamDetails(livestreamId, userToken)]);
            if (!userProfile || !livestream) {
                setIsLoading(false);
    
                return;
            };

            const { data } = userProfile;
            const { GetLiveStreamByID } = livestream;

            const ivKey = GetLiveStreamByID.MeetingID ? generateIV(GetLiveStreamByID.MeetingID) : null;
            const encryptedUID = ivKey ? encrypt(data.UserId, ivKey) : null;
            const userName = encryptedUID ? `${data.NickName} | ${encryptedUID}` : data.NickName;
    
            setZoomCredential({
                userName,
                userEmail: data.Email,
                passWord: GetLiveStreamByID.MeetingPassword,
                meetingNumber: GetLiveStreamByID.MeetingID,
                // apiKey: process.env.REACT_APP_ZOOM_API_KEY,
                sdkKey: process.env.REACT_APP_SDK_KEY,
                signature: GetLiveStreamByID.Signature,
            });
        } catch (e) {
            console.log("getDatas() error check", e, e.message);
            setIsLoading(false);
        }
        
    }

    function startMeeting() {
        const zoomRoot = document.getElementById('zmmtg-root');
        zoomRoot.style.display = 'block';

        const leaveUrl = `${process.env.REACT_APP_DOMAIN}/ended`;

        ZoomMtg.init({
            debug: true,
            leaveUrl,
            isSupportAV: true,
            isSupportPolling: true,
            isSupportQA: true,
            showMeetingHeader: false, //option
            disableInvite: true, //optional
            disableRecord: true, //optional
            videoHeader: false, //optional,
            screenShare: false, //optional,
            meetingInfo: [ // optional
                'topic',
                'dc',
                'enctype',
                'report',
            ],
            success: (success) => {  
                ZoomMtg.join({
                    signature: zoomCredential.signature,
                    meetingNumber: zoomCredential.meetingNumber,
                    userName: zoomCredential.userName,
                    // apiKey: zoomCredential.apiKey,
                    sdkKey: zoomCredential.sdkKey,
                    userEmail: zoomCredential.userEmail,
                    passWord: zoomCredential.passWord,
                    success: (success) => {
                        ZoomMtg.showInviteFunction({
                            show: false
                        });
                    },
                    error: (error) => {
                        console.log(error)
                    }
                })

            },
            error: (error) => {
                console.log(error)
            }
        })
    }

    return (
        <div className="App">
            <main>
                <div className="content-container">
                    {
                        isLoading && (
                            <div className="loading">
                                <Loader />
                                <p>Harap tunggu...</p>
                            </div>
                        )
                    }
                    {
                        !isLoading && (
                            <div className="loading">
                                <p style={{ fontWeight: 700 }}>{!isRequirementsMet ? 'Perangkat Anda tidak mendukung untuk menjalankan aplikasi zoom pada web.' : 'Terjadi kesalahan pada server. Mohon coba ulang kembali.'}</p>
                                <p>Anda akan kembali dalam 3 detik...</p>
                            </div>
                        )
                    }
                    <div className="version">
                        <p style={{ fontSize: 12, fontWeight: 700 }}>{`Zoom Web SDK v${sdkVersion}`}</p>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default OldApp;
